import React from "react";
import { Mail, Phone, MapPin, MessageCircle, Clock, Instagram } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function ContactInfoCards() {
  const { t } = useLanguage();

  return (
    <div className="space-y-5" data-testid="contact-info-cards">
      <Reveal as="a" href="mailto:merhaba@yastikmedya.com"
        className="flex items-start gap-4 rounded-2xl border border-mist bg-white p-5 sm:p-6 hover:border-gold/40 transition-colors group"
        data-testid="contact-card-email"
      >
        <span className="flex-shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-gold">
          <Mail className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-ink/55">{t("contact.cards.email")}</p>
          <p className="mt-1 font-display text-h3 text-ink group-hover:text-gold transition-colors">
            merhaba@yastikmedya.com
          </p>
        </div>
      </Reveal>

      <Reveal as="a" href="https://wa.me/908508884865" target="_blank" rel="noopener noreferrer"
        delay={0.05}
        className="flex items-start gap-4 rounded-2xl border border-mist bg-white p-5 sm:p-6 hover:border-gold/40 transition-colors group"
        data-testid="contact-card-whatsapp"
      >
        <span className="flex-shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-gold">
          <MessageCircle className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-ink/55">{t("contact.cards.whatsapp")}</p>
          <p className="mt-1 font-display text-h3 text-ink group-hover:text-gold transition-colors">
            +90 (850) 888 48 65
          </p>
        </div>
      </Reveal>

      <Reveal as="div" delay={0.1}
        className="flex items-start gap-4 rounded-2xl border border-mist bg-white p-5 sm:p-6"
        data-testid="contact-card-address"
      >
        <span className="flex-shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-gold">
          <MapPin className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-ink/55">{t("contact.cards.address")}</p>
          <p className="mt-1 text-body text-ink leading-relaxed">
            Nispetiye Mah. Aytar Cad. Bilgin Sok.<br />
            Gurup Ap. No:1 D:3/A · Beşiktaş / İstanbul
          </p>
        </div>
      </Reveal>

      <Reveal as="div" delay={0.15}
        className="flex items-start gap-4 rounded-2xl border border-mist bg-white p-5 sm:p-6"
        data-testid="contact-card-hours"
      >
        <span className="flex-shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-gold">
          <Clock className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-ink/55">{t("contact.cards.hours")}</p>
          <p className="mt-1 text-body text-ink">{t("contact.cards.hours_value")}</p>
        </div>
      </Reveal>

      <Reveal as="a" href="https://instagram.com/postunhazir" target="_blank" rel="noopener noreferrer"
        delay={0.2}
        className="flex items-start gap-4 rounded-2xl border border-mist bg-white p-5 sm:p-6 hover:border-gold/40 transition-colors group"
        data-testid="contact-card-instagram"
      >
        <span className="flex-shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-gold">
          <Instagram className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-ink/55">{t("contact.cards.instagram")}</p>
          <p className="mt-1 font-display text-h3 text-ink group-hover:text-gold transition-colors">
            @postunhazir
          </p>
        </div>
      </Reveal>
    </div>
  );
}
